import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserAuthActionsGatewayService } from "./user-auth-action-gateway.service";
import {
  Login,
  LoginStepOne,
  LoginStepThree,
  LoginStepTwo,
} from "src/app/core/models/Login.model";
import {
  LoginAssets,
  LoginStepThreeAssets,
  LoginStepTwoAssets,
} from "../models/login-assets.model";

@Injectable({
  providedIn: "root",
})
export class userAuthActionsFacadeService {
  constructor(
    private userAuthActionsGatewayService: UserAuthActionsGatewayService
  ) {}

  userLogin(user: LoginAssets): Observable<Login> {
    return this.userAuthActionsGatewayService.userLogin(user);
  }

  userLoginStepOne(user: LoginAssets): Observable<LoginStepOne> {
    return this.userAuthActionsGatewayService.userLoginStepOne(user);
  }

  userLoginStepTwo(user: LoginStepTwoAssets): Observable<LoginStepTwo> {
    return this.userAuthActionsGatewayService.userLoginStepTwo(user);
  }

  userLoginStepThree(user: LoginStepThreeAssets): Observable<LoginStepThree> {
    return this.userAuthActionsGatewayService.userLoginStepThree(user);
  }

  resetPasswordRequest(username, captcha): Observable<any> {
    return this.userAuthActionsGatewayService.resetPasswordRequest(username, captcha);
  }

  verifyResetToken(token): Observable<any> {
    return this.userAuthActionsGatewayService.verifyResetToken(token);
  }

  resetPassword(data): Observable<any> {
    return this.userAuthActionsGatewayService.resetPassword(data);
  }

  addCustomer(customer): Observable<any> {
    return this.userAuthActionsGatewayService.addCustomer(customer);
  }

  getSSOToken(data): Observable<any> {
    return this.userAuthActionsGatewayService.getSSOToken(data);
  }

  acceptMerchantInvite(data: any): Observable<any> {
    return this.userAuthActionsGatewayService.acceptMerchantInvite(data);
  }

  acceptNewMerchantInvite(data: any): Observable<any> {
    return this.userAuthActionsGatewayService.acceptNewMerchantInvite(data);
  }

  checkInvitationCode(data: any): Observable<any> {
    return this.userAuthActionsGatewayService.checkInvitationCode(data);
  }
}
